module.exports = __webpack_public_path__ + "static/media/crypto-chart.f27704a3.PNG";